import React, { useState, useEffect } from "react";
import { toast } from 'react-toastify';
import CssCodeEditor from "../../../components/CssCodeEditor";
import JsCodeEditor from "../../../components/JsCodeEditor";
import ColorPicker from "../../../components/ColorPicker";

const AppearanceTab = ({ handleLayoutChange, selectedLayout,updatePricingTableTabData,pricingTableTabData }) => {
    const [activeSettingElementsTab, setActiveSettingElementsTab] = useState("main");
    const [fontType, setFontType] = useState(pricingTableTabData.font_type);
    const [fontTypeDropdownOpen, setFontTypeDropdownOpen] = useState(false);
    const [toggleColor, setToggleColor] = useState(pricingTableTabData.toggle_color);
    const [arrowBackgroundColor, setArrowBackgroundColor] = useState(pricingTableTabData.arrow_background_color);
    const [arrowBackgroundColorOnHover, setArrowBackgroundColorOnHover] = useState(pricingTableTabData.arrow_background_color_on_hover);
    const [arrowOnHoverColor, setArrowOnHoverColor] = useState(pricingTableTabData.arrow_color_on_hover);
    const [arrowColor, setArrowColor] = useState(pricingTableTabData.arrow_color);
    const [arrowSize, setArrowSize] = useState(pricingTableTabData.arrow_size);
    const [showPicture, setShowPicture] = useState(Number(pricingTableTabData.is_show_picture));
    const [showTitle, setShowTitle] = useState(Number(pricingTableTabData.is_show_title));
    const [activeAlignmentSection, setActiveAlignmentSection] = useState(pricingTableTabData.position_alignment);
    const [titleColor, setTitleColor] = useState(pricingTableTabData.title_color);
    const [captionColor, setCaptionColor] = useState(pricingTableTabData.caption_color);
    const [titleSize, setTitleSize] = useState(pricingTableTabData.title_size);
    const [titleSizeDropdownOpen, setTitleSizeDropdownOpen] = useState(false);
    const [captionSize, setCaptionSize] = useState(pricingTableTabData.caption_size);
    const [captionSizeDropdownOpen, setCaptionSizeDropdownOpen] = useState(false);
    const [showFeatures, setShowFeatures] = useState(Number(pricingTableTabData.is_show_features));
    const [featuresActiveAlignmentSection, setFeaturesActiveAlignmentSection] = useState(pricingTableTabData.features_position_alignment);
    const [featuresIconColor, setFeaturesIconColor] = useState(pricingTableTabData.features_icon_color);
    const [featuresTextColor, setFeaturesTextColor] = useState(pricingTableTabData.features_text_color);
    const [showPrice, setShowPrice] = useState(Number(pricingTableTabData.is_show_price));
    const [priceActiveAlignmentSection, setPriceActiveAlignmentSection] = useState(pricingTableTabData.price_position_alignment);
    const [priceColor, setPriceColor] = useState(pricingTableTabData.price_color);
    const [priceCaptionColor, setPriceCaptionColor] = useState(pricingTableTabData.price_caption_color);
    const [priceDiscountTextColor, setPriceDiscountTextColor] = useState(pricingTableTabData.price_discount_text_color);
    const [priceSize, setPriceSize] = useState(pricingTableTabData.price_size);
    const [priceSizeDropdownOpen, setPriceSizeDropdownOpen] = useState(false);
    const [priceDiscountSize, setPriceDiscountSize] = useState(pricingTableTabData.price_discount_size);
    const [priceDiscountSizeDropdownOpen, setPriceDiscountSizeDropdownOpen] = useState(false);
    const [priceCaptionSize, setPriceCaptionSize] = useState(pricingTableTabData.price_caption_size);
    const [priceCaptionSizeDropdownOpen, setPriceCaptionSizeDropdownOpen] = useState(false);
    const [showButton, setShowButton] = useState(Number(pricingTableTabData.is_show_button));
    const [buttonActiveAlignmentSection, setButtonActiveAlignmentSection] = useState(pricingTableTabData.button_position_alignment);
    const [buttonColor, setButtonColor] = useState(pricingTableTabData.button_color);
    const [buttonLabelColor, setButtonLabelColor] = useState(pricingTableTabData.button_label_color);
    const [buttonCaptionColor, setButtontCaptionColor] = useState(pricingTableTabData.button_caption_color);
    const [fullWidth, setShowFullWidth] = useState(Number(pricingTableTabData.is_full_width));
    const [buttonSizeType, setButtontSizeType] = useState(pricingTableTabData.button_size_type);
    const [buttonSizeTypeDropdownOpen, setButtonSizeTypeDropdownOpen] = useState(false);
    const [highLightBackgroundColor, setHighLightBackgroundColor] = useState(pricingTableTabData.high_light_background_color);
    const [highLightTitleColor, setHighLightTextColor] = useState(pricingTableTabData.high_light_title_color);
    const [styleTabCustomCss, setStyleTabCustomCss] = useState(pricingTableTabData.custom_css);
    const [jsTabCustomJs, setJsTabCustomJs] = useState(pricingTableTabData.custom_js);
    
    // Handlers Font Type Change
    const handleFontTypeChange = (font) => {
        setFontType(font);
        updatePricingTableTabData(prev => ({
            ...prev,
            font_type: font
        }));
        setFontTypeDropdownOpen(false);
    };

    // Handlers Toggle Color Change
    const handleToggleColorChange = (color) => {
        setToggleColor(color.hex);
        updatePricingTableTabData("toggle_color", color.hex);
    };

    // Handlers Arrow Background Color Change
    const handleArrowBackgroundColorChange = (color) => {
        setArrowBackgroundColor(color.hex);
        updatePricingTableTabData("arrow_background_color", color.hex);
    };

    // Handlers Arrow Background Color On Hover Change
    const handleBackgroundColorOnHoverChange = (color) => {
        setArrowBackgroundColorOnHover(color.hex);
        updatePricingTableTabData("arrow_background_color_on_hover", color.hex);
    };

    // Handlers Arrow Background Color Change
    const handleArrowOnHoverColorChange = (color) => {
        setArrowOnHoverColor(color.hex);
        updatePricingTableTabData("arrow_color_on_hover", color.hex);
    };

    // Handlers Arrow  Color Change
    const handleArrowColorChange = (color) => {
        setArrowColor(color.hex);
        updatePricingTableTabData("arrow_color", color.hex);
    };

    // Handlers Arrow Size Change
    const handleArrowSizeChange = (e) => {
        const value = e.target.value;
        setArrowSize(value);
        updatePricingTableTabData("arrow_size", value);
    };

    //Handlers Is Show Picture On Change
    const handleShowPictureChange = (e) => {
        const checked = e.target.checked;
        setShowPicture(checked);
        updatePricingTableTabData("is_show_picture", checked); 
    };

    //Handlers Is Show Title On Change
    const handleShowTitleChange = (e) => {
        const checked = e.target.checked;
        setShowTitle(checked);
        updatePricingTableTabData("is_show_title", checked); 
    };

    // Handle Position Alignment change
    const handleActiveAlignmentInputChange = (event) => {
        setActiveAlignmentSection(event.target.value);
        updatePricingTableTabData("position_alignment", event.target.value);
    };

    // Handlers Title Color Change
    const handleTitleColorChange = (color) => {
        setTitleColor(color.hex);
        updatePricingTableTabData("title_color", color.hex);
    };

    // Handlers Caption Color Change
    const handleCaptionColorChange = (color) => {
        setCaptionColor(color.hex);
        updatePricingTableTabData("caption_color", color.hex);
    };

    // Handlers Title Size Change
    const handleTitleSizeChange = (size) => {
        setTitleSize(size);
        updatePricingTableTabData(prev => ({
            ...prev,
            title_size: size
        }));
        setTitleSizeDropdownOpen(false);
    };

    // Handlers Caption Size Change
    const handleCaptionSizeChange = (size) => {
        setCaptionSize(size);
        updatePricingTableTabData(prev => ({
            ...prev,
            caption_size: size
        }));
        setCaptionSizeDropdownOpen(false);
    };

    //Handlers Is Show Features On Change
    const handleShowFeaturesChange = (e) => {
        const checked = e.target.checked;
        setShowFeatures(checked);
        updatePricingTableTabData("is_show_features", checked); 
    };

    // Handle Features Position Alignment change
    const handleFeaturesActiveAlignmentInputChange = (event) => {
        setFeaturesActiveAlignmentSection(event.target.value);
        updatePricingTableTabData("features_position_alignment", event.target.value);
    };

    // Handlers Features Icon Color Change
    const handleFeaturesIconColorChange = (color) => {
        setFeaturesIconColor(color.hex);
        updatePricingTableTabData("features_icon_color", color.hex);
    };

    // Handlers Features Text Color Change
    const handleFeaturesTextColorChange = (color) => {
        setFeaturesTextColor(color.hex);
        updatePricingTableTabData("features_text_color", color.hex);
    };

    //Handlers Is Show Price On Change
    const handleShowPriceChange = (e) => {
        const checked = e.target.checked;
        setShowPrice(checked);
        updatePricingTableTabData("is_show_price", checked); 
    };

    // Handle Price Position Alignment change
    const handlePriceActiveAlignmentInputChange = (event) => {
        setPriceActiveAlignmentSection(event.target.value);
        updatePricingTableTabData("price_position_alignment", event.target.value);
    };

    // Handlers Price Text Color Change
    const handlePriceColorChange = (color) => {
        setPriceColor(color.hex);
        updatePricingTableTabData("price_color", color.hex);
    };

    // Handlers Price Caption Color Change
    const handlePriceCaptionColorChange = (color) => {
        setPriceCaptionColor(color.hex);
        updatePricingTableTabData("price_caption_color", color.hex);
    };

    // Handlers Price Discount Text Color Change
    const handlePriceDiscountTextColorChange = (color) => {
        setPriceDiscountTextColor(color.hex);
        updatePricingTableTabData("discount_text_color", color.hex);
    };

    // Handlers Price Size Change
    const handlePriceSizeChange = (size) => {
        setPriceSize(size);
        updatePricingTableTabData(prev => ({
            ...prev,
            price_size: size
        }));
        setPriceSizeDropdownOpen(false);
    };

    // Handlers Price Discount Size Change
    const handlePriceDiscountSizeChange = (size) => {
        setPriceDiscountSize(size);
        updatePricingTableTabData(prev => ({
            ...prev,
            price_discount_size: size
        }));
        setPriceDiscountSizeDropdownOpen(false);
    };

    // Handlers Price Caption Size Change
    const handlePriceCaptionSizeChange = (size) => {
        setPriceCaptionSize(size);
        updatePricingTableTabData(prev => ({
            ...prev,
            price_caption_size: size
        }));
        setPriceCaptionSizeDropdownOpen(false);
    };

    //Handlers Is Show Button On Change
    const handleShowButtonChange = (e) => {
        const checked = e.target.checked;
        setShowButton(checked);
        updatePricingTableTabData("is_show_button", checked); 
    };

    // Handle Button Position Alignment change
    const handleButtonActiveAlignmentInputChange = (event) => {
        setButtonActiveAlignmentSection(event.target.value);
        updatePricingTableTabData("button_position_alignment", event.target.value);
    };

    // Handlers Button Color Change
    const handleButtonColorChange = (color) => {
        setButtonColor(color.hex);
        updatePricingTableTabData("button_color", color.hex);
    };

    // Handlers Button Label Color Change
    const handleButtonLabelColorChange = (color) => {
        setButtonLabelColor(color.hex);
        updatePricingTableTabData("button_label_color", color.hex);
    };

    // Handlers Button Caption Color Change
    const handleButtontCaptionColorChange = (color) => {
        setButtontCaptionColor(color.hex);
        updatePricingTableTabData("button_caption_color", color.hex);
    };

    //Handlers Is Show Full Width On Change
    const handleShowFullWidthChange = (e) => {
        const checked = e.target.checked;
        setShowFullWidth(checked);
        updatePricingTableTabData("is_full_width", checked); 
    };

    // Handlers Button Size Type Change
    const handleButtonSizeTypeChange = (size) => {
        setButtontSizeType(size);
        updatePricingTableTabData(prev => ({
            ...prev,
            button_size_type: size
        }));
        setButtonSizeTypeDropdownOpen(false);
    };

    // Handlers High Light Background Color Change
    const handleHighLightBackgroundColorChange = (color) => {
        setHighLightBackgroundColor(color.hex);
        updatePricingTableTabData("high_light_background_color", color.hex);
    };

    // Handlers High Light Text Color Change
    const handleHighLightTextColorChange = (color) => {
        setHighLightTextColor(color.hex);
        updatePricingTableTabData("high_light_title_color", color.hex);
    };

    // Handlers Custom CSS Change
    const handleCustomcssCodeChange = (code) => {
        setStyleTabCustomCss(code);
        updatePricingTableTabData("custom_css", code);
    };
    //Inject CSS into the page whenever it changes
    useEffect(() => {
        let styleTag = document.getElementById("custom-style");

        if (!styleTag) {
            styleTag = document.createElement("style");
            styleTag.id = "custom-style";
            document.head.appendChild(styleTag);
        }

        styleTag.innerHTML = styleTabCustomCss || "";
    }, [styleTabCustomCss]);

    // Handlers Custom Js Change
    const handleCustomJsCodeChange = (code) => {
        setJsTabCustomJs(code);
        updatePricingTableTabData("custom_js", code);
    }; 

    // Function to run the JS code when Validate is clicked
    const handleValidateClick = () => { 
        const existingScript = document.getElementById("custom-js");
        if (existingScript) {
            existingScript.remove();
        }
    
        if (jsTabCustomJs && jsTabCustomJs.trim() !== "") {
            const script = document.createElement("script");
            script.id = "custom-js";
            script.type = "text/javascript";
            script.innerHTML = jsTabCustomJs;
    
            document.body.appendChild(script);
    
            toast.success("Custom JS applied successfully");
        } else {
            toast.error("No JS code to apply");
        }
    };
    return (
        <div className="testimonials-side-baar-layout-tab">
            {activeSettingElementsTab === "main" && (
                <>
                    <span>Appearance</span>
                    <div className="side-baar-box-header">
                        <div className="box-header-row">
                            <span>Font</span>
                            <div className="color-pikr-box" onClick={() => setFontTypeDropdownOpen(!fontTypeDropdownOpen)}>
                                <em>{fontType}</em>
                                {fontTypeDropdownOpen && (
                                    <ul className="dropdown-list">
                                        {["Default"].map((font) => (
                                            <li key={font} onClick={() => handleFontTypeChange(font)}>
                                                {font}
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="box-header-row bubble-text">
                        <label>Customize Elements</label>
                    </div>
                    <div className="customize-elements-list">
                        <ul>
                            <li>
                                <button onClick={() => setActiveSettingElementsTab("table_toggle")}>Table Toggle <i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                            <li>
                                <button onClick={() => setActiveSettingElementsTab("column")}>Column <i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                            <li>
                                <button onClick={() => setActiveSettingElementsTab("navigation_arrows")}>Navigation Arrows <i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                            <li>
                                <button onClick={() => setActiveSettingElementsTab("picture")}>Picture <i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                            <li>
                                <button onClick={() => setActiveSettingElementsTab("title")}>Title <i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                            <li>
                                <button onClick={() => setActiveSettingElementsTab("features")}>Features <i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                            <li>
                                <button onClick={() => setActiveSettingElementsTab("price")}>Price <i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                            <li>
                                <button onClick={() => setActiveSettingElementsTab("button")}>Button <i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                            <li>
                                <button onClick={() => setActiveSettingElementsTab("highlight_label")}>Highlight Label <i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                        </ul>
                    </div>
                    <div className="customize-elements-list">
                        <ul>
                            <li>
                                <button onClick={() => setActiveSettingElementsTab("custom_css")}>Custom Css <i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                            <li>
                                <button onClick={() => setActiveSettingElementsTab("custom_js")}>Custom JS <i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                        </ul>
                    </div>
                </>
            )}

            {activeSettingElementsTab === "table_toggle" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveSettingElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button> Table Toggle</span>
                        <div className="box-header-row">
                            <span>Toggle Color</span>
                            <div className="color-pikr-box">
                                <ColorPicker color={toggleColor} setColor={setToggleColor}  onChangeComplete={handleToggleColorChange}/>
                            </div>
                        </div>
                    </div>
                </>
            )} 

            {activeSettingElementsTab === "column" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveSettingElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button> Column</span>
                        <div className="box-header-row">
                            <span>Column Corners</span>
                            <em>
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 20 20"
                                    style={{ width: "20px", height: "20px", fill: "yellow" }}
                                >
                                    <path
                                    fillRule="evenodd"
                                    d="M15.833 4.167V17.5h-1.568V5.735H2.5V4.167z"
                                    ></path>
                                </svg>
                            </em>
                        </div>
                    </div>
                </>
            )} 


            {activeSettingElementsTab === "navigation_arrows" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveSettingElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button> Navigation Arrows</span>
                        <div className="box-header-row">
                            <span>Arrow Background Color</span>
                            <div className="color-pikr-box">
                                <ColorPicker color={arrowBackgroundColor} setColor={setArrowBackgroundColor}  onChangeComplete={handleArrowBackgroundColorChange}/>
                            </div>
                        </div>
                        <div className="box-header-row">
                            <span>Arrow Color</span>
                            <div className="color-pikr-box">
                                <ColorPicker color={arrowColor} setColor={setArrowColor}  onChangeComplete={handleArrowColorChange}/>
                            </div>
                        </div>
                        <div className="box-header-row">
                            <span>Arrow Background Color on Hover</span>
                            <div className="color-pikr-box">
                                <ColorPicker color={arrowBackgroundColorOnHover} setColor={setArrowBackgroundColorOnHover} onChangeComplete={handleBackgroundColorOnHoverChange}/>
                            </div>
                        </div>
                        <div className="box-header-row">
                            <span>Arrow Color on Hover</span>
                            <div className="color-pikr-box">
                                <ColorPicker color={arrowOnHoverColor} setColor={setArrowOnHoverColor}  onChangeComplete={handleArrowOnHoverColorChange}/>
                            </div>
                        </div>
                        <div className="box-header-row">
                            <span>Arrow Size</span>
                            <em>{arrowSize}</em>
                            <div className="slider-container">
                                <input type="range" min="24" max="64" value={arrowSize} onChange={handleArrowSizeChange}/>
                            </div>
                        </div>
                    </div>
                </>
            )} 

            {activeSettingElementsTab === "picture" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveSettingElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button> Picture</span>
                        <div className="box-header-row"><span>Show Picture</span>
                            <div className="form-group">
                                <input id="open_is_show_picture" className="chkbx-toggle" type="checkbox" checked={showPicture} onChange={handleShowPictureChange} />
                                <label for="open_is_show_picture"></label> 
                            </div>
                        </div>
                    </div>
                </>
            )} 


            {activeSettingElementsTab === "title" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveSettingElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button> Title</span>
                        <div className="side-baar-box-header">
                            <div className="box-header-row"><span>Show Title</span>
                                <div className="form-group">
                                    <input id="open_is_show_title" className="chkbx-toggle" type="checkbox" checked={showTitle} onChange={handleShowTitleChange} />
                                    <label for="open_is_show_title"></label> 
                                </div>
                            </div>
                        </div>

                        <div className="side-baar-box-header">
                            <div className="box-header-row">
                                <p>Alignment</p>
                                <div className="left-cnater-right-button">
                                    <label className="card-radio-btn">
                                        <input type="radio" name="alignment_type" className="card-input-element d-none" value="left" onChange={handleActiveAlignmentInputChange} checked={activeAlignmentSection === "left"} />
                                        <div className="card card-body">
                                            <div className="content_sub">Left</div>
                                        </div>
                                    </label>
                                    <label className="card-radio-btn">
                                        <input type="radio" name="alignment_type" className="card-input-element d-none" value="center" onChange={handleActiveAlignmentInputChange} checked={activeAlignmentSection === "center"} />
                                        <div className="card card-body">
                                            <div className="content_sub">Center</div>
                                        </div>
                                    </label>
                                    <label className="card-radio-btn">
                                        <input type="radio" name="alignment_type" className="card-input-element d-none" value="right" onChange={handleActiveAlignmentInputChange} checked={activeAlignmentSection === "right"} />
                                        <div className="card card-body">
                                            <div className="content_sub">Right</div>
                                        </div>
                                    </label>
                                </div>
                            </div>
                        </div>

                        <div className="side-baar-box-header">
                            <div className="box-header-row">
                                <span>Title Color</span>
                                <div className="color-pikr-box">
                                    <ColorPicker color={titleColor} setColor={setTitleColor} onChangeComplete={handleTitleColorChange}/>
                                </div>
                            </div>
                            <div className="box-header-row">
                                <span>Caption Color</span>
                                <div className="color-pikr-box">
                                    <ColorPicker color={captionColor} setColor={setCaptionColor} onChangeComplete={handleCaptionColorChange}/>
                                </div>
                            </div>
                        </div>

                        <div className="side-baar-box-header">
                            <div className="box-header-row">
                                <span>Title Size</span>
                                <div className="color-pikr-box" onClick={() => setTitleSizeDropdownOpen(!titleSizeDropdownOpen)}>
                                    <em>{titleSize}</em>
                                    {titleSizeDropdownOpen && (
                                        <ul className="dropdown-list">
                                            {["12px","14px","16px","18px","20px","22px","24px","26px","28px","30px"].map((size) => (
                                                <li key={size} onClick={() => handleTitleSizeChange(size)}>
                                                    {size}
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                </div>
                            </div>
                            <div className="box-header-row">
                                <span>Caption Size</span>
                                <div className="color-pikr-box" onClick={() => setCaptionSizeDropdownOpen(!captionSizeDropdownOpen)}>
                                    <em>{captionSize}</em>
                                    {captionSizeDropdownOpen && (
                                        <ul className="dropdown-list">
                                            {["12px","14px","16px","18px","20px","22px","24px","26px","28px","30px"].map((size) => (
                                                <li key={size} onClick={() => handleCaptionSizeChange(size)}>
                                                    {size}
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )} 

            {activeSettingElementsTab === "features" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveSettingElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button> Features</span>
                        <div className="side-baar-box-header">
                            <div className="box-header-row"><span>Show Features</span>
                                <div className="form-group">
                                    <input id="open_is_show_features" className="chkbx-toggle" type="checkbox" checked={showFeatures} onChange={handleShowFeaturesChange} />
                                    <label for="open_is_show_features"></label> 
                                </div>
                            </div>
                        </div>

                        {Number(pricingTableTabData.is_show_features) === 1 && (
                        <>
                            <div className="side-baar-box-header">
                                <div className="box-header-row">
                                    <p>Alignment</p>
                                    <div className="left-cnater-right-button">
                                        <label className="card-radio-btn">
                                            <input type="radio" name="features_alignment_type" className="card-input-element d-none" value="left" onChange={handleFeaturesActiveAlignmentInputChange} checked={featuresActiveAlignmentSection === "left"} />
                                            <div className="card card-body">
                                                <div className="content_sub">Left</div>
                                            </div>
                                        </label>
                                        <label className="card-radio-btn">
                                            <input type="radio" name="features_alignment_type" className="card-input-element d-none" value="center" onChange={handleFeaturesActiveAlignmentInputChange} checked={featuresActiveAlignmentSection === "center"} />
                                            <div className="card card-body">
                                                <div className="content_sub">Center</div>
                                            </div>
                                        </label>
                                        <label className="card-radio-btn">
                                            <input type="radio" name="features_alignment_type" className="card-input-element d-none" value="right" onChange={handleFeaturesActiveAlignmentInputChange} checked={featuresActiveAlignmentSection === "right"} />
                                            <div className="card card-body">
                                                <div className="content_sub">Right</div>
                                            </div>
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div className="side-baar-box-header">
                                <div className="box-header-row">
                                    <span>Icon Color</span>
                                    <div className="color-pikr-box">
                                        <ColorPicker color={featuresIconColor} setColor={setFeaturesIconColor} onChangeComplete={handleFeaturesIconColorChange}/>
                                    </div>
                                </div>
                                <div className="box-header-row">
                                    <span>Text Color</span>
                                    <div className="color-pikr-box">
                                        <ColorPicker color={featuresTextColor} setColor={setFeaturesTextColor} onChangeComplete={handleFeaturesTextColorChange}/>
                                    </div>
                                </div>
                            </div>
                            <div className="side-baar-box-header">
                                <div className="box-header-row">
                                    <span>Font Size</span>
                                    <div className="color-pikr-box" onClick={() => setCaptionSizeDropdownOpen(!captionSizeDropdownOpen)}>
                                        <em>{captionSize}</em>
                                        {captionSizeDropdownOpen && (
                                            <ul className="dropdown-list">
                                                {["12px","14px","16px","18px","20px","22px","24px","26px","28px","30px"].map((size) => (
                                                    <li key={size} onClick={() => handleCaptionSizeChange(size)}>
                                                        {size}
                                                    </li>
                                                ))}
                                            </ul>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </>
                       )} 
                    </div>
                </>
            )} 


            {activeSettingElementsTab === "price" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveSettingElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button> Price</span>
                        <div className="side-baar-box-header">
                            <div className="box-header-row"><span>Show Price</span>
                                <div className="form-group">
                                    <input id="open_is_show_price" className="chkbx-toggle" type="checkbox" checked={showPrice} onChange={handleShowPriceChange} />
                                    <label for="open_is_show_price"></label> 
                                </div>
                            </div>
                        </div>

                        {Number(pricingTableTabData.is_show_price) === 1 && (
                        <>
                            <div className="side-baar-box-header">
                                <div className="box-header-row">
                                    <p>Alignment</p>
                                    <div className="left-cnater-right-button">
                                        <label className="card-radio-btn">
                                            <input type="radio" name="price_alignment_type" className="card-input-element d-none" value="left" onChange={handlePriceActiveAlignmentInputChange} checked={priceActiveAlignmentSection === "left"} />
                                            <div className="card card-body">
                                                <div className="content_sub">Left</div>
                                            </div>
                                        </label>
                                        <label className="card-radio-btn">
                                            <input type="radio" name="price_alignment_type" className="card-input-element d-none" value="center" onChange={handlePriceActiveAlignmentInputChange} checked={priceActiveAlignmentSection === "center"} />
                                            <div className="card card-body">
                                                <div className="content_sub">Center</div>
                                            </div>
                                        </label>
                                        <label className="card-radio-btn">
                                            <input type="radio" name="price_alignment_type" className="card-input-element d-none" value="right" onChange={handlePriceActiveAlignmentInputChange} checked={priceActiveAlignmentSection === "right"} />
                                            <div className="card card-body">
                                                <div className="content_sub">Right</div>
                                            </div>
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div className="side-baar-box-header">
                                <div className="box-header-row">
                                    <span>Price Color</span>
                                    <div className="color-pikr-box">
                                        <ColorPicker color={priceColor} setColor={setPriceColor} onChangeComplete={handlePriceColorChange}/>
                                    </div>
                                </div>
                                <div className="box-header-row">
                                    <span>Caption Color</span>
                                    <div className="color-pikr-box">
                                        <ColorPicker color={priceCaptionColor} setColor={setPriceCaptionColor} onChangeComplete={handlePriceCaptionColorChange}/>
                                    </div>
                                </div>
                                <div className="box-header-row">
                                    <span>Discount Text Color</span>
                                    <div className="color-pikr-box">
                                        <ColorPicker color={priceDiscountTextColor} setColor={setPriceDiscountTextColor} onChangeComplete={handlePriceDiscountTextColorChange}/>
                                    </div>
                                </div>
                            </div>
                            <div className="side-baar-box-header">
                                <div className="box-header-row">
                                    <span>Price Size</span>
                                    <div className="color-pikr-box" onClick={() => setPriceSizeDropdownOpen(!priceSizeDropdownOpen)}>
                                        <em>{priceSize}</em>
                                        {priceSizeDropdownOpen && (
                                            <ul className="dropdown-list">
                                                {["12px","14px","16px","18px","20px","22px","24px","26px","28px","30px"].map((size) => (
                                                    <li key={size} onClick={() => handlePriceSizeChange(size)}>
                                                        {size}
                                                    </li>
                                                ))}
                                            </ul>
                                        )}
                                    </div>
                                </div>
                                <div className="box-header-row">
                                    <span>Discount Size</span>
                                    <div className="color-pikr-box" onClick={() => setPriceDiscountSizeDropdownOpen(!priceDiscountSizeDropdownOpen)}>
                                        <em>{priceDiscountSize}</em>
                                        {priceDiscountSizeDropdownOpen && (
                                            <ul className="dropdown-list">
                                                {["12px","14px","16px","18px","20px","22px","24px","26px","28px","30px"].map((size) => (
                                                    <li key={size} onClick={() => handlePriceDiscountSizeChange(size)}>
                                                        {size}
                                                    </li>
                                                ))}
                                            </ul>
                                        )}
                                    </div>
                                </div>
                                <div className="box-header-row">
                                    <span>Caption Size</span>
                                    <div className="color-pikr-box" onClick={() => setPriceCaptionSizeDropdownOpen(!priceCaptionSizeDropdownOpen)}>
                                        <em>{priceCaptionSize}</em>
                                        {priceCaptionSizeDropdownOpen && (
                                            <ul className="dropdown-list">
                                                {["12px","14px","16px","18px","20px","22px","24px","26px","28px","30px"].map((size) => (
                                                    <li key={size} onClick={() => handlePriceCaptionSizeChange(size)}>
                                                        {size}
                                                    </li>
                                                ))}
                                            </ul>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </>
                       )} 
                    </div>
                </>
            )} 

            {activeSettingElementsTab === "button" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveSettingElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button> Button</span>
                        <div className="side-baar-box-header">
                            <div className="box-header-row"><span>Show Button</span>
                                <div className="form-group">
                                    <input id="open_is_show_button" className="chkbx-toggle" type="checkbox" checked={showButton} onChange={handleShowButtonChange} />
                                    <label for="open_is_show_button"></label> 
                                </div>
                            </div>
                        </div>

                        {Number(pricingTableTabData.is_show_button) === 1 && (
                        <>
                            <div className="side-baar-box-header">
                                <div className="box-header-row">
                                    <span>Button Color</span>
                                    <div className="color-pikr-box">
                                        <ColorPicker color={buttonColor} setColor={setButtonColor} onChangeComplete={handleButtonColorChange}/>
                                    </div>
                                </div>
                                <div className="box-header-row">
                                    <span>Label Color</span>
                                    <div className="color-pikr-box">
                                        <ColorPicker color={buttonLabelColor} setColor={setButtonLabelColor} onChangeComplete={handleButtonLabelColorChange}/>
                                    </div>
                                </div>
                                <div className="box-header-row">
                                    <span>Caption Color</span>
                                    <div className="color-pikr-box">
                                        <ColorPicker color={buttonCaptionColor} setColor={setButtontCaptionColor} onChangeComplete={handleButtontCaptionColorChange}/>
                                    </div>
                                </div>
                            </div>
                            <div className="side-baar-box-header">
                                <div className="box-header-row"><span>Full Width</span>
                                    <div className="form-group">
                                        <input id="open_is_full_width" className="chkbx-toggle" type="checkbox" checked={fullWidth} onChange={handleShowFullWidthChange} />
                                        <label for="open_is_full_width"></label> 
                                    </div>
                                </div>
                                <div className="box-header-row">
                                    <span>Size</span>
                                    <div className="color-pikr-box" onClick={() => setButtonSizeTypeDropdownOpen(!buttonSizeTypeDropdownOpen)}>
                                        <em>{buttonSizeType}</em>
                                        {buttonSizeTypeDropdownOpen && (
                                            <ul className="dropdown-list">
                                                {["Small","Medium","Large"].map((size) => (
                                                    <li key={size} onClick={() => handleButtonSizeTypeChange(size)}>
                                                        {size}
                                                    </li>
                                                ))}
                                            </ul>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </>
                       )} 
                       {Number(pricingTableTabData.is_full_width) === 1 && (
                        <>
                       <div className="side-baar-box-header">
                            <div className="box-header-row">
                                <p>Alignment</p>
                                <div className="left-cnater-right-button">
                                    <label className="card-radio-btn">
                                        <input type="radio" name="button_alignment_type" className="card-input-element d-none" value="left" onChange={handleButtonActiveAlignmentInputChange} checked={buttonActiveAlignmentSection === "left"} />
                                        <div className="card card-body">
                                            <div className="content_sub">Left</div>
                                        </div>
                                    </label>
                                    <label className="card-radio-btn">
                                        <input type="radio" name="button_alignment_type" className="card-input-element d-none" value="center" onChange={handleButtonActiveAlignmentInputChange} checked={buttonActiveAlignmentSection === "center"} />
                                        <div className="card card-body">
                                            <div className="content_sub">Center</div>
                                        </div>
                                    </label>
                                    <label className="card-radio-btn">
                                        <input type="radio" name="button_alignment_type" className="card-input-element d-none" value="right" onChange={handleButtonActiveAlignmentInputChange} checked={buttonActiveAlignmentSection === "right"} />
                                        <div className="card card-body">
                                            <div className="content_sub">Right</div>
                                        </div>
                                    </label>
                                </div>
                            </div>
                        </div>
                        </>
                       )} 
                    </div>
                </>
            )} 

            {activeSettingElementsTab === "highlight_label" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveSettingElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button> Highlight Label</span>
                        <div className="side-baar-box-header">
                            <div className="box-header-row">
                                <span>Background Color</span>
                                <div className="color-pikr-box">
                                    <ColorPicker color={highLightBackgroundColor} setColor={setHighLightBackgroundColor} onChangeComplete={handleHighLightBackgroundColorChange}/>
                                </div>
                            </div>
                            <div className="box-header-row">
                                <span>Text Color</span>
                                <div className="color-pikr-box">
                                    <ColorPicker color={highLightTitleColor} setColor={setHighLightTextColor} onChangeComplete={handleHighLightTextColorChange}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )} 

            {activeSettingElementsTab === "custom_css" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveSettingElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button> Custom CSS</span>
                        <div className="css-text height-text">
                            <CssCodeEditor code={styleTabCustomCss} setCode={setStyleTabCustomCss} onChangeComplete={handleCustomcssCodeChange}/>
                        </div>
                    </div>
                </>
            )} 

            {activeSettingElementsTab === "custom_js" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveSettingElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button> Custom Js</span>
                        <div className="css-text height-text">
                            <JsCodeEditor code={jsTabCustomJs} setCode={setJsTabCustomJs} onChangeComplete={handleCustomJsCodeChange}/>
                            <div className="save-css-js"><button className="save-css-js" onClick={handleValidateClick}>Validate</button></div>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};

export default AppearanceTab;